import React from 'react';
import { Link } from 'react-router-dom';
import logoFooter from '../img/logo.png';
import logoMuu from '../img/Logo_Muu_500px.png';
import flagParaguay from '../img/Paraguay.png';
import footerBg from '../img/footer.jpg';

require('../scss/bootstrap.min.css');

const Footer = () => {
	const footerStyle = {
		backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), url(${footerBg})`
	};

	return (
		<footer className="style-3">
			<div className="footer-wrapper" style={footerStyle}>
				<div className="container">
					<div className="footer-menu-wrap">
						<div className="row g-lg-4 gy-5">

							{/* Columna 1: Logo e Info de Contacto */}
							<div className="col-lg-4 col-sm-6 d-flex align-items-center justify-content-lg-center justify-content-start">
								<div className="footer-logo-area">
									<img width="200px" style={{ marginBottom: '5px' }} src={logoFooter} alt="El Rodeo Logo" />

									<div className="social-area">
										<p className="mt-30">
											Republica Francesa 390 Esq. 25 de Mayo
										</p>
										<p>Asunción - Paraguay</p>
										<p><a className="white-color" href="tel:+595981577462">Tel: +595 981 577462</a></p>
										<p>Email: <a className="white-color" href="mailto:elrodeo@elrodeo.com.py">elrodeo@elrodeo.com.py</a></p>
									</div>
								</div>
							</div>

							{/* Columna 2: Accesos */}
							<div className="col-lg-2 col-sm-6">
								<div className="footer-widget">
									<div className="widget-title">
										<h4>Accesos</h4>
									</div>
									<div className="menu-container">
										<ul className="widget-list">
											<li><a href="https://elrodeo.muumercadoganadero.com/subastas-online">Subastas Online</a></li>
											<li><a href="https://elrodeo.muumercadoganadero.com/cierre-inmediato">Cierre Inmediato</a></li>
											<li><a href="https://elrodeo.muumercadoganadero.com/venta-directa">Ventas Particulares</a></li>
											<li><a href="https://elrodeo.muumercadoganadero.com/remates">Remates</a></li>
										</ul>
									</div>
								</div>
							</div>

							{/* Columna 3: Importante */}
							<div className="col-lg-2 col-sm-6">
								<div className="footer-widget">
									<div className="widget-title">
										<h4>Importante</h4>
									</div>
									<div className="menu-container">
										<ul className="widget-list">
											<li><a href="https://elrodeo.muumercadoganadero.com/comoOfertar">¿Cómo ofertar?</a></li>
											<li><a href="https://elrodeo.muumercadoganadero.com/comoVender">¿Cómo vender?</a></li>
										</ul>
									</div>
								</div>
							</div>

							{/* Columna 4: Logo Muu */}
							<div className="col-lg-4 col-sm-6 d-flex align-items-center justify-content-lg-center justify-content-start">
								<div className="footer-logo-area">
									<div className="footer-logo">
										<p className="mb-10" style={{ color: '#fff' }}>Desarrollado e Integrado con </p>
										<a target="_blank" rel="noreferrer" href="https://muumercadoganadero.com.ar">
											<img src={logoMuu} alt="Muu Mercado Ganadero" />
										</a>
									</div>
								</div>
							</div>

						</div>
					</div>

					{/* Footer Bottom */}
					<div className="footer-bottom">
						<div className="copyright-area">
							<p>©Copyright 2024 <a href="https://muumercadoganadero.com.ar">Muu Mercado Digital Ganadero</a> | Design By <a href="https://www.egenslab.com/">Egens Lab</a></p>
						</div>
						<div className="footer-bottom-right">
							<ul>
								<li><a href="#" className="version-link">Versión: 1.0.1</a></li>
								<li><img width="50px" style={{ borderRadius: '4px' }} src={flagParaguay} alt="Paraguay" /></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
